var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81007 7.89011C4.4315 7.56216 4.24222 7.39818 4.10609 7.2281C3.5443 6.52618 3.42433 5.56817 3.7957 4.74941C3.88569 4.55102 4.02869 4.34543 4.31471 3.93426C4.60072 3.52309 4.74373 3.31751 4.89843 3.16415C5.53688 2.53121 6.47671 2.3106 7.3301 2.59335C7.53688 2.66186 7.75642 2.78234 8.1955 3.0233L10.1168 4.07765C10.8577 4.48427 11.2282 4.68758 11.4732 4.93591C12.102 5.57316 12.3216 6.50863 12.042 7.35911C11.933 7.69053 11.6917 8.03745 11.2091 8.7313C10.7264 9.42515 10.4851 9.77207 10.2123 9.98948C9.51219 10.5474 8.55885 10.6668 7.7428 10.2987C7.4248 10.1553 7.10538 9.87854 6.46654 9.32512L4.81007 7.89011Z",
    fill: "url(#paint0_linear_9308_7402)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_9308_7402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.78707 7.26896C5.10608 6.67901 4.97977 5.67033 5.49427 4.9307C6.00877 4.19107 6.99831 3.95879 7.78816 4.39224L8.92379 5.01546C9.91333 5.5585 10.214 6.83954 9.56945 7.76617C8.92487 8.69281 7.61936 8.85627 6.76619 8.11717L5.78707 7.26896Z",
    fill: "#0062FF"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -3.59188,
    y: 0.706828,
    width: 22.1838,
    height: 20.8852
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.2px)",
      clipPath: "url(#bgblur_0_9308_7402_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4.40816
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_9308_7402",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4.29858,
    width: 15,
    height: 13,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 4.29858,
    width: 15,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5125 12.1091C12.9788 12.1091 12.5446 11.6788 12.5446 11.15C12.5446 10.6205 12.9788 10.1902 13.5125 10.1902C13.6418 10.1902 13.766 10.1393 13.857 10.0491C13.9487 9.95831 14 9.83528 14 9.7071L13.9993 7.96662C13.9993 6.4954 12.791 5.29858 11.3064 5.29858H3.6936C2.209 5.29858 1.00065 6.4954 1.00065 7.96662L1 9.76314C1 9.89132 1.05135 10.0144 1.143 10.1052C1.234 10.1954 1.35815 10.2462 1.4875 10.2462C2.03935 10.2462 2.45535 10.6347 2.45535 11.15C2.45535 11.6788 2.02115 12.1091 1.4875 12.1091C1.2184 12.1091 1 12.3255 1 12.5922V14.3314C1 15.8026 2.2077 17.0001 3.69295 17.0001H11.307C12.7923 17.0001 14 15.8026 14 14.3314V12.5922C14 12.3255 13.7816 12.1091 13.5125 12.1091Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.5125 12.1091C12.9788 12.1091 12.5446 11.6788 12.5446 11.15C12.5446 10.6205 12.9788 10.1902 13.5125 10.1902C13.6418 10.1902 13.766 10.1393 13.857 10.0491C13.9487 9.95831 14 9.83528 14 9.7071L13.9993 7.96662C13.9993 6.4954 12.791 5.29858 11.3064 5.29858H3.6936C2.209 5.29858 1.00065 6.4954 1.00065 7.96662L1 9.76314C1 9.89132 1.05135 10.0144 1.143 10.1052C1.234 10.1954 1.35815 10.2462 1.4875 10.2462C2.03935 10.2462 2.45535 10.6347 2.45535 11.15C2.45535 11.6788 2.02115 12.1091 1.4875 12.1091C1.2184 12.1091 1 12.3255 1 12.5922V14.3314C1 15.8026 2.2077 17.0001 3.69295 17.0001H11.307C12.7923 17.0001 14 15.8026 14 14.3314V12.5922C14 12.3255 13.7816 12.1091 13.5125 12.1091Z",
    fill: "#477FFF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5125 12.2928C13.6139 12.2928 13.6962 12.2105 13.6962 12.1091C13.6962 12.0077 13.6139 11.9254 13.5125 11.9254V12.2928ZM13.857 10.0491L13.7277 9.91867L13.857 10.0491ZM14 9.7071H14.1837V9.70703L14 9.7071ZM13.9993 7.96662H13.8157V7.96669L13.9993 7.96662ZM1.00065 7.96662L1.18432 7.96669V7.96662H1.00065ZM1 9.76314L0.816327 9.76307V9.76314H1ZM1.143 10.1052L1.27229 9.97471L1.143 10.1052ZM13.5125 11.9254C13.4111 11.9254 13.3288 12.0077 13.3288 12.1091C13.3288 12.2105 13.4111 12.2928 13.5125 12.2928V11.9254ZM13.5125 12.1091V11.9254C13.0787 11.9254 12.7283 11.5758 12.7283 11.15H12.5446H12.361C12.361 11.7818 12.879 12.2928 13.5125 12.2928V12.1091ZM12.5446 11.15H12.7283C12.7283 10.7234 13.0788 10.3739 13.5125 10.3739V10.1902V10.0065C12.8789 10.0065 12.361 10.5176 12.361 11.15H12.5446ZM13.5125 10.1902V10.3739C13.6898 10.3739 13.8606 10.3042 13.9863 10.1796L13.857 10.0491L13.7277 9.91867C13.6714 9.97445 13.5939 10.0065 13.5125 10.0065V10.1902ZM13.857 10.0491L13.9863 10.1796C14.1126 10.0544 14.1837 9.88451 14.1837 9.7071H14H13.8163C13.8163 9.78605 13.7847 9.86218 13.7277 9.91867L13.857 10.0491ZM14 9.7071L14.1837 9.70703L14.183 7.96655L13.9993 7.96662L13.8157 7.96669L13.8163 9.70716L14 9.7071ZM13.9993 7.96662H14.183C14.183 6.39234 12.8908 5.11491 11.3064 5.11491V5.29858V5.48226C12.6912 5.48226 13.8157 6.59846 13.8157 7.96662H13.9993ZM11.3064 5.29858V5.11491H3.6936V5.29858V5.48226H11.3064V5.29858ZM3.6936 5.29858V5.11491C2.10919 5.11491 0.816977 6.39234 0.816977 7.96662H1.00065H1.18432C1.18432 6.59846 2.30881 5.48226 3.6936 5.48226V5.29858ZM1.00065 7.96662L0.816977 7.96656L0.816327 9.76307L1 9.76314L1.18367 9.7632L1.18432 7.96669L1.00065 7.96662ZM1 9.76314H0.816327C0.816327 9.94055 0.887422 10.1105 1.01371 10.2356L1.143 10.1052L1.27229 9.97471C1.21528 9.91822 1.18367 9.84209 1.18367 9.76314H1ZM1.143 10.1052L1.01371 10.2356C1.13943 10.3602 1.31017 10.4299 1.4875 10.4299V10.2462V10.0626C1.40613 10.0626 1.32857 10.0305 1.27229 9.97471L1.143 10.1052ZM1.4875 10.2462V10.4299C1.94997 10.4299 2.27168 10.7478 2.27168 11.15H2.45535H2.63902C2.63902 10.5216 2.12873 10.0626 1.4875 10.0626V10.2462ZM2.45535 11.15H2.27168C2.27168 11.5758 1.92128 11.9254 1.4875 11.9254V12.1091V12.2928C2.12102 12.2928 2.63902 11.7818 2.63902 11.15H2.45535ZM1.4875 12.1091V11.9254C1.11853 11.9254 0.816327 12.2225 0.816327 12.5922H1H1.18367C1.18367 12.4285 1.31827 12.2928 1.4875 12.2928V12.1091ZM1 12.5922H0.816327V14.3314H1H1.18367V12.5922H1ZM1 14.3314H0.816327C0.816327 15.9056 2.1078 17.1837 3.69295 17.1837V17.0001V16.8164C2.3076 16.8164 1.18367 15.6996 1.18367 14.3314H1ZM3.69295 17.0001V17.1837H11.307V17.0001V16.8164H3.69295V17.0001ZM11.307 17.0001V17.1837C12.8922 17.1837 14.1837 15.9056 14.1837 14.3314H14H13.8163C13.8163 15.6996 12.6924 16.8164 11.307 16.8164V17.0001ZM14 14.3314H14.1837V12.5922H14H13.8163V14.3314H14ZM14 12.5922H14.1837C14.1837 12.2225 13.8815 11.9254 13.5125 11.9254V12.1091V12.2928C13.6817 12.2928 13.8163 12.4285 13.8163 12.5922H14Z",
    fill: "url(#paint1_linear_9308_7402)",
    mask: "url(#path-3-outside-1_9308_7402)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 2.36892,
    y: 5.92385,
    width: 10.2623,
    height: 10.0776
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.38px)",
      clipPath: "url(#bgblur_1_9308_7402_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9308_7402)",
    "data-figma-bg-blur-radius": 2.7551
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72999 10.8814L8.96364 11.6277L9.14499 12.6828C9.17619 12.8655 9.10274 13.0456 8.95259 13.1535C8.80374 13.2627 8.60939 13.2763 8.44559 13.1892L7.49984 12.6919L6.55214 13.1899C6.48194 13.2269 6.40524 13.2464 6.32919 13.2464C6.22974 13.2464 6.13159 13.2152 6.04709 13.1541C5.89759 13.0456 5.82414 12.8655 5.85534 12.6828L6.03604 11.6277L5.26969 10.8814C5.13709 10.7527 5.09094 10.5635 5.14814 10.3874C5.20599 10.2119 5.35549 10.087 5.53814 10.061L6.59504 9.90696L7.06889 8.94679C7.15144 8.78167 7.31654 8.67896 7.49984 8.67896H7.50114C7.68509 8.67961 7.85019 8.78232 7.93144 8.94744L8.40529 9.90696L9.46414 10.0617C9.64484 10.087 9.79434 10.2119 9.85154 10.3874C9.90939 10.5635 9.86324 10.7527 9.72999 10.8814Z",
    fill: "url(#paint2_linear_9308_7402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.69751H7.50098C7.67793 8.69814 7.83686 8.79658 7.91504 8.95532L8.38867 9.91528L8.39355 9.92407L8.40234 9.92505L9.46191 10.0803C9.63539 10.1048 9.77894 10.2242 9.83398 10.3928C9.88966 10.5624 9.84494 10.7446 9.7168 10.8684L8.95117 11.6145L8.94434 11.6213L8.94531 11.6311L9.12695 12.6858C9.15325 12.8398 9.1023 12.9918 8.99219 13.0969L8.94141 13.1389C8.81621 13.2306 8.65784 13.2516 8.51465 13.1995L8.4541 13.1731L7.50879 12.676L7.5 12.6711L7.49121 12.676L6.54395 13.1741C6.47626 13.2098 6.40202 13.2278 6.3291 13.2278C6.23357 13.2278 6.13898 13.1978 6.05762 13.1389C5.914 13.0344 5.84305 12.8614 5.87305 12.6858L6.05371 11.6311L6.05566 11.6213L6.04883 11.6145L5.28223 10.8684C5.15475 10.7446 5.11096 10.5624 5.16602 10.3928C5.22177 10.2242 5.3654 10.1043 5.54102 10.0793L6.59766 9.92505L6.60742 9.92407L6.61133 9.91528L7.08496 8.95532C7.16443 8.79636 7.32373 8.69751 7.5 8.69751Z",
    stroke: "url(#paint3_linear_9308_7402)",
    strokeOpacity: 0.5,
    strokeWidth: 0.0367347
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7402",
    x: 1.50512,
    y: 0.501336,
    width: 12.0784,
    height: 11.7532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.83673,
    result: "effect1_foregroundBlur_9308_7402"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7402_clip_path",
    transform: "translate(3.59188 -0.706828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5125 12.1091C12.9788 12.1091 12.5446 11.6788 12.5446 11.15C12.5446 10.6205 12.9788 10.1902 13.5125 10.1902C13.6418 10.1902 13.766 10.1393 13.857 10.0491C13.9487 9.95831 14 9.83528 14 9.7071L13.9993 7.96662C13.9993 6.4954 12.791 5.29858 11.3064 5.29858H3.6936C2.209 5.29858 1.00065 6.4954 1.00065 7.96662L1 9.76314C1 9.89132 1.05135 10.0144 1.143 10.1052C1.234 10.1954 1.35815 10.2462 1.4875 10.2462C2.03935 10.2462 2.45535 10.6347 2.45535 11.15C2.45535 11.6788 2.02115 12.1091 1.4875 12.1091C1.2184 12.1091 1 12.3255 1 12.5922V14.3314C1 15.8026 2.2077 17.0001 3.69295 17.0001H11.307C12.7923 17.0001 14 15.8026 14 14.3314V12.5922C14 12.3255 13.7816 12.1091 13.5125 12.1091Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9308_7402",
    x: 2.36892,
    y: 5.92385,
    width: 10.2623,
    height: 10.0776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.918367,
    dy: 0.918367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.918367
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.498039 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7402"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7402",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7402_clip_path",
    transform: "translate(-2.36892 -5.92385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72999 10.8814L8.96364 11.6277L9.14499 12.6828C9.17619 12.8655 9.10274 13.0456 8.95259 13.1535C8.80374 13.2627 8.60939 13.2763 8.44559 13.1892L7.49984 12.6919L6.55214 13.1899C6.48194 13.2269 6.40524 13.2464 6.32919 13.2464C6.22974 13.2464 6.13159 13.2152 6.04709 13.1541C5.89759 13.0456 5.82414 12.8655 5.85534 12.6828L6.03604 11.6277L5.26969 10.8814C5.13709 10.7527 5.09094 10.5635 5.14814 10.3874C5.20599 10.2119 5.35549 10.087 5.53814 10.061L6.59504 9.90696L7.06889 8.94679C7.15144 8.78167 7.31654 8.67896 7.49984 8.67896H7.50114C7.68509 8.67961 7.85019 8.78232 7.93144 8.94744L8.40529 9.90696L9.46414 10.0617C9.64484 10.087 9.79434 10.2119 9.85154 10.3874C9.90939 10.5635 9.86324 10.7527 9.72999 10.8814Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7402",
    x1: 6.06375,
    y1: 1.41987,
    x2: 5.33304,
    y2: 10.9364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#477FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#477FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7402",
    x1: 3.06939,
    y1: 6.66182,
    x2: 12.564,
    y2: 17.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7402",
    x1: 9.53913,
    y1: 9.50375,
    x2: 4.24629,
    y2: 9.68329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7402",
    x1: 5.63592,
    y1: 10.2111,
    x2: 9.67104,
    y2: 10.2343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.6ac228bc23669250720f3a5a0dbca13d.svg";
export { ForwardRef as ReactComponent };